import { useState } from 'react'
import { Flex } from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { BodyText, OtherText } from 'styling/Typography'
import { StatusPill } from 'components/ui/StatusPill/StatusPill'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { Cell } from 'components/HonestTable/HonestTable.styled'
import { IExceptionsTabProps } from 'types/foodLogistics/foodTabProps.interface'
import { IFoodException } from 'types/foodLogistics/foodException.interface'
import { ResolveExceptionModal } from '../components/ResolveExceptionModal'

const sevRank: Record<string, number> = { Critical: 0, High: 1, Medium: 2, Low: 3 }

export const ExceptionsTab = ({ exceptions, resolveException }: IExceptionsTabProps) => {
  const [selected, setSelected] = useState<IFoodException | null>(null)

  const sorted = [...exceptions].sort((a, b) =>
    a.status === b.status ? sevRank[a.sev] - sevRank[b.sev] : a.status === 'Open' ? -1 : 1,
  )

  const columns: IHonestTableColumn<IFoodException>[] = [
    {
      id: 'sev',
      header: 'Severity',
      sticky: true,
      minWidth: '8rem',
      cell: (e) => (
        <Cell>
          <StatusPill status={e.sev === 'Critical' ? 'danger' : e.sev === 'High' ? 'accent' : 'info'}>{e.sev}</StatusPill>
        </Cell>
      ),
    },
    { id: 'type', header: 'Type', cell: (e) => <BodyText>{e.type}</BodyText> },
    { id: 'meal', header: 'Meal', cell: (e) => <BodyText>{e.meal}</BodyText> },
    { id: 'kitchen', header: 'Kitchen', cell: (e) => <BodyText>{e.kitchen}</BodyText> },
    { id: 'person', header: 'Person', cell: (e) => <BodyText>{e.person}</BodyText> },
    {
      id: 'root',
      header: 'Root Cause',
      minWidth: '18rem',
      cell: (e) => <OtherText grey>{e.root}</OtherText>,
    },
    {
      id: 'status',
      header: 'Status',
      cell: (e) => (
        <StatusPill status={e.status === 'Open' ? 'success' : 'accent'}>{e.status}</StatusPill>
      ),
    },
    {
      id: 'action',
      header: '',
      align: 'right',
      cell: (e) =>
        e.status === 'Open' ? (
          <Button variant='primary' size='sm' onClick={() => setSelected(e)}>
            Resolve
          </Button>
        ) : (
          <OtherText grey>via {e.res}</OtherText>
        ),
    },
  ]

  return (
    <Flex column gap='1rem' width='100%'>
      <HonestTable columns={columns} data={sorted} keyField='id' />

      {selected && (
        <ResolveExceptionModal
          exception={selected}
          closeModal={() => setSelected(null)}
          onResolve={(actionKey, comment) => {
            resolveException(selected, actionKey, comment)
            setSelected(null)
          }}
        />
      )}
    </Flex>
  )
}
